import { useState } from "react";
import { Bell, ArrowLeft } from "react-bootstrap-icons";
import { Button, Dropdown, Nav, Navbar } from "react-bootstrap";
import {
  dashboard_search_normal,
  kirkos_merchant_profile,
} from "../../../assets/images";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CustomerDetails } from "../../../types";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { log_out } from "../../../services/axios.instance";
import { clearBookingValues } from "../../../Redux/BookingData/bookingDataSlice";
import { useDispatch } from "react-redux";
// import DehazeIcon from '@mui/icons-material/Dehaze';

const PanelLeftClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/><path d="m16 15-3-3 3-3"/></svg>
);

const PanelLeftOpen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/><path d="m14 9 3 3-3 3"/></svg>
);

interface customerDashboardSidebarProps {
  selectedNavToggle: boolean;
  setSelectedNavToggle: (toggle: boolean) => void;
}

const CustomerDashBoardNavbar: React.FC<customerDashboardSidebarProps> = ({
  setSelectedNavToggle,
  selectedNavToggle,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Dynamic Title Mapping based on current path
  const getPageInfo = () => {
    const path = location.pathname;
    if (path.includes("myaccount")) return { title: "Dashboard Overview", sub: "Welcome back! Here's what's happening." };
    if (path.includes("rentdeals")) return { title: "Track Your Order", sub: "View and manage your active rental deals." };
    if (path.includes("orders")) return { title: "Order History", sub: "Review your past rentals and invoices." };
    if (path.includes("contactus")) return { title: "Contact Support", sub: "Need help? We're just a message away." };
    if (path.includes("managemyprofile")) return { title: "Manage Profile", sub: "Update your personal information." };
    return { title: "Customer Dashboard", sub: "Modern Rental Experience" };
  };

  const pageInfo = getPageInfo();

  const isOrdersPage = location.pathname === "/customer/orders";
  const isRentDealsPage = location.pathname === "/customer/rentdeals";
  const isRentDealsDetailsPage = location.pathname === "/customer/rentdealsdetails";
  const isBookingCalendarPage = location.pathname === "/customer/bookingcalender";
  const isOrderEditPage = location.pathname === "/customer/order/edit";
  const isOrderDetailsPage = location.pathname === "/customer/order/details";

  const showBackButton =
    isOrdersPage ||
    isRentDealsPage ||
    isRentDealsDetailsPage ||
    isBookingCalendarPage ||
    isOrderEditPage ||
    isOrderDetailsPage;

  const backTarget = isOrderEditPage || isOrderDetailsPage
    ? "/customer/orders"
    : isRentDealsDetailsPage
      ? "/customer/rentdeals"
      : "/customer/myaccount";

  return (
    <div className="header-glass-card">
      <div className="d-flex align-items-center">
        <Button
          className="side-bar-collapse-btn me-3"
          onClick={() => setSelectedNavToggle(!selectedNavToggle)}
        >
          {showBackButton ? (
            <ArrowLeft />
          ) : selectedNavToggle ? (
            <PanelLeftOpen />
          ) : (
            <PanelLeftClose />
          )}
        </Button>

        <div className="page-title-section">
          <h1 className="page-title">{pageInfo.title}</h1>
          <span className="page-subtitle">{pageInfo.sub}</span>
        </div>
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* <button className="nav-link search-bar-bg border-0 bg-transparent p-2">
          <img
            alt="search"
            src={dashboard_search_normal}
            width="24"
            height="24"
          />
        </button>
        <div className="position-relative">
          <Bell size={20} color="white" cursor="pointer" />
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem' }}>
            3
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default CustomerDashBoardNavbar;
